<template>
  <div class="frisbuy-slide-blur">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      style="
        margin: auto;
        background: transparent;
        display: block;
        shape-rendering: auto;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
      "
      width="150px"
      height="150px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="50"
        cy="50"
        r="0"
        fill="none"
        stroke="#000000"
        stroke-width="2"
      >
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="1.3157894736842106s"
          values="0;40"
          keyTimes="0;1"
          keySplines="0 0.2 0.8 1"
          calcMode="spline"
          begin="0s"
        />
        <animate
          attributeName="opacity"
          repeatCount="indefinite"
          dur="1.3157894736842106s"
          values="1;0"
          keyTimes="0;1"
          keySplines="0.2 0 0.8 1"
          calcMode="spline"
          begin="0s"
        />
      </circle>
      <circle
        cx="50"
        cy="50"
        r="0"
        fill="none"
        stroke="#000000"
        stroke-width="2"
      >
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="1.3157894736842106s"
          values="0;40"
          keyTimes="0;1"
          keySplines="0 0.2 0.8 1"
          calcMode="spline"
          begin="-0.6578947368421053s"
        />
        <animate
          attributeName="opacity"
          repeatCount="indefinite"
          dur="1.3157894736842106s"
          values="1;0"
          keyTimes="0;1"
          keySplines="0.2 0 0.8 1"
          calcMode="spline"
          begin="-0.6578947368421053s"
        />
      </circle>
    </svg>
  </div>
</template>

<style scoped lang="scss">
.frisbuy-slide-blur {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 0.7;
  z-index: 1;
}
</style>

<script>
export default {
  data() {
    return {};
  },
};
</script>
